import { QueryContextProps } from "utils/hooks"
import { BuildHashIdsQuery } from "utils/interfaces"

export function buildHashIdsQuery({
    hashIds,
    resultsKey,
    source,
    skipStorage = false,
    publicServicesOnly = false,
    includeLegalInfo = false,
}: BuildHashIdsQuery): QueryContextProps {
    return {
        url: `psychologists_by_hash_ids`,
        method: "POST",
        hash_ids: hashIds,
        jsonData: {
            hash_ids: hashIds,
            mode: source?.true_mode || source?.mode,
            public_services_only: publicServicesOnly,
            include_legal_info: includeLegalInfo,
        },
        resultsKey,
        source,
        skipStorage,
    }
}
